import * as React from "react"
import { GoogleLogin } from "../components/googleLogin"
import { Page } from "../layout/page"
import { Card } from "../components/card"
import { LoadingSpinnerSvg } from "components/svg"
import { useRedirectResult } from "shared/useRedirectResult"
import { loginWithGoogle } from "shared/loginWithGoogle"
import Link from "next/link"

const GoogleSignIn = () => {
  const { loading, error } = useRedirectResult()

  React.useEffect(() => {
    if (!loading && !error) {
      loginWithGoogle()
    }
  }, [loading, error])

  return (
    <Page>
      <div className="overflow-hidden mt-16 flex flex-col items-center">
        <Card className="w-full lg:w-2/3 xl:w-1/3">
          <h1 className="text-2xl font-light mb-4 text-center">
            Continue to Adventurekeep
          </h1>
          {loading && (
            <div className="flex justify-center">
              <LoadingSpinnerSvg height={32} width={32} />
            </div>
          )}
          {!loading && (
            <>
              {error && (
                <div className="flex flex-col items-center">
                  <p className="text-red-600">
                    There was an error signing in. Please try again.
                  </p>
                  <Link href="/">Go back</Link>
                </div>
              )}
            </>
          )}
        </Card>
      </div>
    </Page>
  )
}

export default GoogleSignIn
